import { render, staticRenderFns } from "./riskHazardPicture.vue?vue&type=template&id=cb16cbe0"
import script from "./riskHazardPicture.vue?vue&type=script&lang=js"
export * from "./riskHazardPicture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb16cbe0')) {
      api.createRecord('cb16cbe0', component.options)
    } else {
      api.reload('cb16cbe0', component.options)
    }
    module.hot.accept("./riskHazardPicture.vue?vue&type=template&id=cb16cbe0", function () {
      api.rerender('cb16cbe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/common/hazard/riskHazardPicture.vue"
export default component.exports